import React from "react";

const Story = () => {
  return (
    <div className="py-10">
      <div className="space-y-3 mb-9">
        <p className="font-semibold text-sm text-primary">Our story</p>
        <h3 className="lg:text-3xl text-2xl font-bold">
          We're just getting started
        </h3>
        <p className="text-lg text-accent">
          We've already helped over 4,000 companies achieve remarkable results
        </p>
      </div>
      <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-10">
        <div className="space-y-3 text-accent">
          <p>
            Morbi sed imperdiet in ipsum, adipiscing elit dui lectus. Tellus id
            scelerisque est ultricies ultricies. Duis est sit sed leo nisl,
            blandit elit sagittis. Quisque tristique consequat quam sed. Nisl at
            scelerisque amet nulla purus habitasse.
          </p>
          <p>
            Nunc sed faucibus bibendum feugiat sed interdum. Ipsum egestas
            condimentum mi massa. In tincidunt pharetra consectetur sed duis
            facilisis metus. Etiam egestas in nec sed et. Quis lobortis at sit
            dictum eget nibh tortor commodo cursus.
          </p>
        </div>
        <div className="space-y-3 text-accent">
          <ul className="list-disc">
            <li>Mi tincidunt elit, id quisque ligula ac diam, amet.</li>
            <li>
              Vel etiam suspendisse morbi eleifend faucibus eget vestibulum.
            </li>
            <li>Tellus aliquam enim urna, etiam. Mauris posuere vulputate.</li>
          </ul>
          <p>
            Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris
            id. Non pellentesque congue eget consectetur turpis. Sapien, dictum
            molestie sem tempor. Diam elit, orci, tincidunt aenean tempus.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Story;
